export default function indexById<T extends { id: string }>(elements: T[]): { [key: string]: T } {
  return elements.reduce(
    (out, element) => {
      out[element.id] = element;
      return out;
    },
    {} as { [key: string]: T },
  );
}
